/**
 * External Imports
 */
import { FC } from 'react';
import { connect } from 'react-redux';

/**
 * Nexus Imports
 */
import { NeuTooltip } from '@neutron/react';

/**
 * Internal Imports
 */
import FilterBtn from '../filterBtn';
import { RootState } from '../../../redux/store';

/**
 * Global Type Definition Imports
 */

/**
 * Style Imports
 */
import { HelpIcon } from '../SearchHeader.styles';
import {
  CompHeaderContainer,
  DateRangeSection,
  HintSection
} from './ComplianceHeader.styles';
import DownloadExportCsvBtn from '../downloadExportCsvBtn/DownloadExportCsvBtn';

interface IComplianceHeaderProps {
  handleExportCsv: () => void;
  handleClickDownloadPDF: () => void;
}

const ComplianceHeader: FC<IComplianceHeaderProps> = ({
  handleExportCsv,
  handleClickDownloadPDF
}) => {
  return (
    <CompHeaderContainer>
      <FilterBtn />
      <DateRangeSection>
        <HintSection>
          <NeuTooltip tip="Compliance Report displays the rounds completed from the Direct Reports or Delegated List using the Day 30-60-90 and Standard Employee Templates. The departments and date ranges can be customized by utilizing the Filter button.">
            <div style={{ width: '12em' }}>
              <HelpIcon size="1x" color="blue" fill={false} className="ms-1">
                help
              </HelpIcon>
              <span className="neu-text-blue-60 ms-1">
                What is this report?
              </span>
            </div>
          </NeuTooltip>
        </HintSection>
      </DateRangeSection>
      <DownloadExportCsvBtn
        handleClickDownloadPDF={handleClickDownloadPDF}
        handleExportCsv={handleExportCsv}
        fileNamePrefix="compliance-report"
      />
    </CompHeaderContainer>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    modalState: state.ModalReducer.modal,
    patientSummaryReportFilter: state.ReportReducer.patientSummaryReportFilter
  };
};

export default connect(mapReduxStateToProps)(ComplianceHeader);
